import { injectGlobal } from 'vue-styled-components';
import { FONTS } from '../shared/constants';
import { COLORS } from '../shared/colors';

injectGlobal`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
    padding: 0;
    font-family: ${FONTS.STANLEY};
   }

  h1 {
    color: ${COLORS.GRAY};
    font-size: 3.0em;
    margin-bottom: 40px;
    text-transform: capitalize;
    font-family: ${FONTS.STANLEY};
    text-align: center;
   }

  h2 {
    color: ${COLORS.GRAY};
    font-size: 2em;
    text-align: center;
    margin: 0;
    font-family: ${FONTS.STANLEY};
    text-transform: capitalize;
  }
`;
